// eslint-disable-next-line import/no-unresolved -- swiper/bundle is a valid package export; resolver doesn't follow package.json "exports"
import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", function () {
    const tabsBlocks = document.querySelectorAll(".section.tabs");

    tabsBlocks.forEach((tabsBlock) => {
        const headerWrapper = tabsBlock.querySelector(".tabs__header-wrapper.swiper");
        const tabsItems = Array.from(tabsBlock.querySelectorAll(".tabs__header-item"));

        if (!tabsItems.length) return;

        let headerSwiper = null;
        const mobileMq = window.matchMedia("(max-width: 767px)");

        const getContentEl = (tabId) => {
            if (!tabId) return null;
            // IDs may contain characters needing escaping (ACF block ids are safe, but be defensive)
            return tabsBlock.querySelector(`#${CSS.escape(tabId)}`);
        };

        const slideToTab = (tabEl) => {
            if (!headerSwiper) return;
            const index = tabsItems.indexOf(tabEl);
            if (index < 0) return;
            headerSwiper.slideTo(index, 300);
        };

        const updateSwiper = () => {
            if (!headerWrapper) return;

            if (mobileMq.matches && !headerSwiper) {
                headerSwiper = new Swiper(headerWrapper, {
                    slidesPerView: "auto",
                    spaceBetween: 16,
                    freeMode: true,
                    watchOverflow: true,
                });

                const activeTab = tabsBlock.querySelector(".tabs__header-item.active");
                if (activeTab) slideToTab(activeTab);
            }

            if (!mobileMq.matches && headerSwiper) {
                headerSwiper.destroy(true, true);
                headerSwiper = null;
            }
        };

        updateSwiper();

        tabsItems.forEach((item) => {
            item.addEventListener("click", function () {
                const tabId = this.dataset.tab;
                const contentItem = getContentEl(tabId);

                if (this.classList.contains("active")) return;

                this.classList.add("active");
                contentItem?.classList.add("active");
                slideToTab(this);

                tabsItems.forEach((other) => {
                    if (other === this) return;
                    other.classList.remove("active");
                    const otherContentItem = getContentEl(other.dataset.tab);
                    otherContentItem?.classList.remove("active");
                });
            });
        });

        window.addEventListener("resize", () => {
            updateSwiper();
        });
    });
});